import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('rps_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fileUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  if (path.startsWith('/api/')) return `${BACKEND_URL}${path}`;
  return `${API_BASE}/files/${path}`;
};

// Thumbnail proxy — serves resized WebP versions of remote product images
// (CJ CDN etc.) for dramatically faster grid loads. Local/relative URLs are
// returned untouched.
export const thumb = (url, w = 400) => {
  if (!url || typeof url !== 'string') return url;
  if (!url.startsWith('http')) return fileUrl(url);
  return `${API_BASE}/img?u=${encodeURIComponent(url)}&w=${w}`;
};

export default api;
